export default __webpack_public_path__ + "static/media/GothamXLight.7737169c.otf";